import { render, staticRenderFns } from "./AccountClosingIndex.vue?vue&type=template&id=6faa72b5"
import script from "./AccountClosingIndex.vue?vue&type=script&lang=js"
export * from "./AccountClosingIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports